import { render, staticRenderFns } from "./reportCustomComponentManageList.vue?vue&type=template&id=51b0a9c2&scoped=true"
import script from "./reportCustomComponentManageList.vue?vue&type=script&lang=js"
export * from "./reportCustomComponentManageList.vue?vue&type=script&lang=js"
import style0 from "./reportCustomComponentManageList.vue?vue&type=style&index=0&id=51b0a9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0a9c2",
  null
  
)

export default component.exports